import { twMerge } from 'tailwind-merge';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-accent-600 text-white hover:bg-accent-700 disabled:bg-accent-600/50',
  secondary: 'border border-brand-900 text-brand-900 bg-white hover:bg-brand-50 disabled:opacity-50',
  ghost: 'text-brand-900 hover:bg-brand-50 disabled:opacity-50',
  danger: 'border border-accent-700 text-accent-700 bg-white hover:bg-accent-50 disabled:opacity-50',
};

const SIZES: Record<ButtonSize, string> = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3.5 text-base',
};

/** Button-Optik auch für Links (z. B. `<Link className={buttonClasses()}>`). */
export function buttonClasses(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', className?: string): string {
  return twMerge(
    'inline-flex items-center justify-center gap-2 rounded-md font-semibold transition-colors disabled:cursor-not-allowed',
    VARIANTS[variant],
    SIZES[size],
    className,
  );
}
